import { IonContent } from '@ionic/react';
import React from 'react';

import { ReviewCards } from '@/components/ReviewCards';
import { UiTypography } from '@/components/ui/Typography';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { OwnAiTitle } from '../../components/Title';

import { SettingUpProfileAnimation } from './components/Animation/Animation';
import { ScreenSettingUpProfileStyles } from './SettingUpProfile.styles';

export const ScreenSettingUpProfile: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'SettingUpProfile',
      });
    }
  }, []);

  const { refreshUser } = useAccount();

  const onFinishAnimation = async () => {
    await userService.createOrUpdate({
      onboarding_data: {
        onboarded: true,
      },
    });
    refreshUser();
  };

  return (
    <ScreenSettingUpProfileStyles>
      <OwnAiTitle className="setting-up-title">
        Setting up your profile...
      </OwnAiTitle>
      <OnboardingSubtitle className="setting-up-subtitle">
        It will take less than one minute
      </OnboardingSubtitle>

      <IonContent>
        <SettingUpProfileAnimation onFinish={onFinishAnimation} />

        <section className="setting-up-user-reviews">
          <UiTypography variant="title-medium" align="center" transform="bold">
            Trusted by 1,556,867 users
          </UiTypography>
          <ReviewCards />
        </section>
      </IonContent>
    </ScreenSettingUpProfileStyles>
  );
};
